/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Credit_Trial_ApplyInputs */

const en_video_credit_trial_apply = /** @type {(inputs: Video_Credit_Trial_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use 480p · 4s`)
};

const es_video_credit_trial_apply = /** @type {(inputs: Video_Credit_Trial_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar 480p · 4 s`)
};

/**
* | output |
* | --- |
* | "Use 480p · 4s" |
*
* @param {Video_Credit_Trial_ApplyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const video_credit_trial_apply = /** @type {((inputs?: Video_Credit_Trial_ApplyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Credit_Trial_ApplyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_video_credit_trial_apply(inputs)
	return es_video_credit_trial_apply(inputs)
});